import { MutationTree } from 'vuex';
import { TranslationsState } from '@/types/state';
import { StaticTranslationInterface, LanguageInterface } from '@/types/translations';

const mutations: MutationTree<TranslationsState> = {
  setLanguages(state, languages: LanguageInterface[]) {
    state.languages = languages;
  },

  setTranslationKeys(state, keys: string[]) {
    state.translationKeys = keys;
  },

  setStaticTranslationsLoaded(state) {
    state.staticTranslationsLoaded = true;
  },

  setStaticTranslations(state, translations: StaticTranslationInterface[]) {
    state.staticTranslations = translations;
  },

  addStaticTranslation(state, translation: StaticTranslationInterface) {
    state.staticTranslations.push(translation);
  },

  updateStaticTranslation(state, translation: StaticTranslationInterface) {
    const index = state.staticTranslations
      .map((trans) => trans.id).indexOf(translation.id);

    if (index > -1) {
      state.staticTranslations.splice(index, 1, translation);
    }
  },

  deleteStaticTranslation(state, translation: StaticTranslationInterface) {
    const index = state.staticTranslations
      .map((trans) => trans.id).indexOf(translation.id);

    if (index > -1) {
      state.staticTranslations.splice(index, 1);
    }
  },

};

export default mutations;
